import { css } from "styled-components";
import { InputIcon, InputWrapper } from "../../../../../../../../inputs/input/styled.js";
import { FontMixin } from "../../../../../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../../../../../styles/common/mixins/logical.styled.js";
const veciPersonCounterSelectStyles = {
    PersonCounterSelectWrapper: ()=>css`
		border-color: ${({ theme  })=>theme.border.color.light};
		${BorderRadius({
            all: '4px'
        })}
	`,
    AgeSelect: ()=>css`
		${InputWrapper} {
			--outline-width: 1px;
			--outline-color-default: ${({ theme  })=>theme.border.color.light};
		}

		${InputIcon} {
			${FontMixin({
            weight: 'bold'
        })}
		}
	`
};
export default veciPersonCounterSelectStyles;

//# sourceMappingURL=veci.js.map